import axios from 'axios'
import { ProblemDetails } from '@/api/generated/model'

const detailOf = (body: unknown): string | undefined => {
  const detail = (body as Partial<ProblemDetails> | null)?.detail
  return typeof detail === 'string' && detail.trim() !== '' ? detail : undefined
}

/**
 * The message to show for a failed API call. The API returns RFC 7807 ProblemDetails, and its
 * `detail` says what was wrong, for example which grid filter it cannot apply (DEV-1551). Without
 * one (a network error, a 500 with no body) the fallback is shown.
 *
 * @param error What the call threw: an axios error, or a ProblemDetails body a fetch caller parsed.
 * @param fallback The message when the error carries no detail.
 */
export const apiErrorMessage = (error: unknown, fallback: string): string => {
  if (axios.isAxiosError(error)) {
    return detailOf(error.response?.data) ?? fallback
  }

  return detailOf(error) ?? fallback
}
